export default {
  openButton: "Generar descriptores con IA",
  title: "Creación rápida con IA — {entity}",
  close: "Cerrar",
  // Fallbacks de los nombres alternativos institucionales.
  matterProgramLabel: "Programa de la Asignatura",
  matterLabel: "la Asignatura",
  descriptors: "Descriptores de {entity}",
  noDescriptors:
    "La institución no tiene descriptores definidos para {entity}.",
  generating: "Generando contenido con IA...",
  generateError:
    "No fue posible generar el contenido. Intente nuevamente más tarde.",
  cancel: "Cancelar",
  confirmSave: "Confirmar y guardar",
  savedToast: "Objetos creados correctamente.",
  saveError:
    "Ocurrió un error al guardar los objetos generados. Intente nuevamente.",
};
